import commonUtil from '../common-util/index';
import { KNG_FILE_TYPE } from '../select-kng/src/const';
export const staticBaseUrl = window.feConfig.common.staticBaseUrl || 'https://stc.yxt.com/';

export const getSystemCoverImages = (needAll) => {
  let imgUrl;
  const url = staticBaseUrl + 'ufd/55a3e0/kng/pc/img/system/';
  if (needAll) {
    const tempArr = [];
    for (let i = 1; i <= 50; i++) {
      tempArr.push(url + i + '.jpg');
    }
    imgUrl = tempArr;
  } else {
    const imgIndex = Math.floor(Math.random() * 50 + 1);
    imgUrl = url + imgIndex + '.jpg';
  }
  return imgUrl;
};

export const getDefaultKngTypeCover = (type) => {
  let imgUrl;
  const url = staticBaseUrl + 'ufd/55a3e0/kng/pc/img/kng/';
  let defaultLanguage = 'zh';
  if (commonUtil.getLanguage()) {
    switch (commonUtil.getLanguage()) {
      case 'ha':
      case 'zh-TW':
        defaultLanguage = 'ha';
        break;
      case 'en':
        defaultLanguage = 'en';
        break;
      default:
        defaultLanguage = 'zh';
        break;
    }
  }
  switch (type) {
    case 'audio':
      imgUrl = url + defaultLanguage + '/audio.png';
      break;
    case 'course':
      imgUrl = url + defaultLanguage + '/course.png';
      break;
    case 'ebook':
    case 'html':
      imgUrl = url + defaultLanguage + '/ebook.png';
      break;
    case 'excel':
      imgUrl = url + defaultLanguage + '/excel.png';
      break;
    case 'image':
    case 'img':
      imgUrl = url + defaultLanguage + '/image.png';
      break;
    case 'pdf':
      imgUrl = url + defaultLanguage + '/pdf.png';
      break;
    case 'ppt':
      imgUrl = url + defaultLanguage + '/ppt.png';
      break;
    case 'scorm':
      imgUrl = url + defaultLanguage + '/scorm.png';
      break;
    case 'video':
      imgUrl = url + defaultLanguage + '/video.png';
      break;
    case 'xuanyes':
      imgUrl = url + defaultLanguage + '/weike.png';
      break;
    case 'word':
      imgUrl = url + defaultLanguage + '/word.png';
      break;
    case 'smart':
      imgUrl = url + defaultLanguage + '/smart.png';
      break;
    case 'exam':
      imgUrl = url + defaultLanguage + '/exam.png';
      break;
    case 'sourcecode':
    case 'zip':
      imgUrl = url + defaultLanguage + '/sourcecode.png';
      break;
    case 'newlink':
      imgUrl = url + defaultLanguage + '/newlink.png';
      break;
    default:
      imgUrl = url + defaultLanguage + '/ukn.png';
      break;
  }
  return imgUrl;
};

// 获取可滚动的父亲
export const getScrollParent = (element) => {
  let node = element;
  while (node &&
    node.nodeType === document.ELEMENT_NODE &&
    node.tagName !== 'HTML' &&
    node.tagName !== 'BODY' &&
    node !== window
  ) {
    const { overflowY } = window.getComputedStyle(node);

    if (/scroll|auto/i.test(overflowY)) {
      return node;
    }
    node = node.parentNode;
  }
  return window;
};

export const getDurationFormat = time => {
  const hours = Math.floor(time / 60 / 60);
  const minutes = Math.floor((time - hours * 60 * 60) / 60);
  const seconds = time - hours * 60 * 60 - minutes * 60;
  const list = [];
  if (hours > 0) {
    list.push(hours > 9 ? hours : '0' + hours);
  }
  list.push(minutes > 9 ? minutes : '0' + minutes);
  list.push(seconds > 9 ? seconds : '0' + seconds);
  return list.join(':');
};
export const handleUploadFileSize = (value) => {
  if (!value) {
    return '0 Bytes';
  }
  value = parseFloat(value) * 1024;
  const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;
  const srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  let size = srcsize / Math.pow(1024, index);
  size = size.toFixed(0);
  return [size + unitArr[index], size, unitArr[index]];
};

export const getTreeNodePathByKey = (curKey, data) => {
  let path = [];
  let node;
  try {
    let traverse = (curKey, data) => {
      if (data.length === 0) {
        return;
      }
      for (let item of data) {
        path.push(item);
        if (item.id === curKey) {
          node = item;
          throw (new Error(''));
        }

        const children = Array.isArray(item.children) ? item.children : [];
        traverse(curKey, children);
        path.pop();
      }
    };
    traverse(curKey, data);
  } catch (e) {}
  return {path, node};
};

export const getScoreWithConfig = (info, config) => {
  const {scormStandard, scormStandardScore, htmlStandard, htmlStandardScore, xuanyesStandard, xuanyesStandardScore, xuanyesMaxScore} = config;
  if (info.fileType === KNG_FILE_TYPE.HTML) {
    return (info.studyHours * htmlStandardScore / (htmlStandard * 60)).toFixed(2);
  } else if (info.fileType === KNG_FILE_TYPE.SCORM) {
    return (info.studyHours * scormStandardScore / (scormStandard * 60)).toFixed(2);
  } else if (info.fileType === KNG_FILE_TYPE.WEIKE) {
    return Math.min((info.studyHours * xuanyesStandardScore / (xuanyesStandard * 60)).toFixed(2), xuanyesMaxScore) ;
  }
  return info.studyScore || 0;
};

export const sleep = duration => {
  return new Promise(resolve => setTimeout(resolve, duration));
};

export const isZhOrHa = ['zh', 'ha', 'zh-TW'].includes(commonUtil.getLanguage());
